//IMPORTAÇÃO DAS BIBLIOTECAS---------------------------------------------------
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google'; // login google
import { ClipLoader } from "react-spinners"; // Icone de Carregamento spinner
import { useTranslation } from 'react-i18next';
import { FaGlobe, FaGooglePlay } from 'react-icons/fa';
import { FcGoogle } from 'react-icons/fc';




//IMPORTAÇÃO DOS MÓDULOS-------------------------------------------------------
import { api } from '../../services/api.js';
import { startWebSocket } from '../../services/websocket.js';
import * as googleOAuth from '../../services/googleOAuth.js';
import styles from "./login.module.css";
import logoLoad from '../../img/logo1.png';
import logoLoadDarkTheme from '../../img/logo2.png';
import logoHeader from '../../img/logo6.png';
import ForgotPasswordModal from "./components/ForgotPasswordModal.js";
import { useAppContext } from "../../AppContext.js";
import { AppLogin } from "./components/appLogin.js";



// COMPONENTE------------------------------------------------------------------
export default function Login() {

  // idioma
  const { t } = useTranslation();

  //variáveis
  const [showFirstLogin, setShowFirstLogin] = useState(false); // estado para mostrar modal de primeiro login
  const [email, setEmail] = useState(""); // armazenha variável email
  const [senha, setSenha] = useState(""); // armazena variável senha
  const [continuarConectado, setContinuarConectado] = useState(false); // armazena variável 'continuar conectado'
  const [loading, setLoading] = useState(false); // estado para mostrar modal load
  const [formLogin, setformLogin] = useState(false); // estado para mostrar formulário de login
  const [isSubmitting, setIsSubmitting] = useState(false); // estado para efeitos do botão submit
  const [errorMessage, setErrorMessage] = useState(""); // mensagem de erro
  const [isForgotPasswordModalOpen, setForgotPasswordModalOpen] = useState(false); // modal para solicitação de nova senha
  const navigate = useNavigate(); // variável para navegação
  const { isApp } = useAppContext(); // define se está sendo acessado pelo app ou pelo site



  // Gerencia efeitos colaterais do painel de recuperação de senha (scroll lock, fechar com ESC).
  useEffect(() => {
    if (!isForgotPasswordModalOpen) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const handleEsc = (e) => {
      if (e.key === "Escape") setForgotPasswordModalOpen(false);
    };
    window.addEventListener("keydown", handleEsc);
    return () => {
      document.body.style.overflow = previousOverflow || "";
      window.removeEventListener("keydown", handleEsc);
    };
  }, [isForgotPasswordModalOpen]);



  //funções para manipulação de IndexedDB e geração de email local
  const DB_NAME = 'tsnotes_local_data';
  const DB_VERSION = 1;
  const STORE_NAME = 'local_accounts';
  const FAKE_EMAIL_KEY = 'fake_email';

  const openIndexedDb = () => {
    return new Promise((resolve, reject) => {
      if (typeof window === 'undefined' || !window.indexedDB) {
        return reject(new Error('IndexedDB not supported'));
      }

      const request = window.indexedDB.open(DB_NAME, DB_VERSION);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME);
        }
      };

      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  };

  const getIndexedDbValue = async (key) => {
    try {
      const db = await openIndexedDb();
      return await new Promise((resolve, reject) => {
        const transaction = db.transaction(STORE_NAME, 'readonly');
        const store = transaction.objectStore(STORE_NAME);
        const request = store.get(key);

        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);

        transaction.oncomplete = () => db.close();
      });
    } catch (error) {
      return null;
    }
  };

  const setIndexedDbValue = async (key, value) => {
    try {
      const db = await openIndexedDb();
      return await new Promise((resolve, reject) => {
        const transaction = db.transaction(STORE_NAME, 'readwrite');
        const store = transaction.objectStore(STORE_NAME);
        const request = store.put(value, key);

        request.onsuccess = () => resolve();
        request.onerror = () => reject(request.error);

        transaction.oncomplete = () => db.close();
      });
    } catch (error) {
      localStorage.setItem(key, value);
    }
  };

  const createLocalEmail = () => {
    const uuid = (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function')
      ? crypto.randomUUID().replace(/-/g, '').slice(0, 28)
      : Array.from({ length: 28 }, () => Math.floor(Math.random() * 16).toString(16)).join('');
    return `local_${uuid}@toskyapps.local.web`;
  };

  const loginLocalInProgress = useRef(false);


  // funcção para logar na conta de usuário local
  async function loginWithLocalAccount() {
    if (loginLocalInProgress.current) {
      return false;
    }
    loginLocalInProgress.current = true;

    try {
      // solicita ao app android o email de usuário localmente salvo para tentar login automático
      if (window.Android && typeof window.Android.getEmail === 'function') {
        const emailFromApp = await window.Android.getEmail();
        if (emailFromApp) {
          const localLoginResponse = await api.post('/auth/local', {
            localEmail: emailFromApp,
            language: navigator.language || 'en-US'
          });

          // envia token para camada nativa do android (WebView) para autenticação nas requisições
          if (window.Android && typeof window.Android.setCookie === 'function') {
            window.Android.setCookie("token", localLoginResponse.data.token);
          }

          if (localLoginResponse.status === 200) {
            localStorage.setItem('contConectado', true);
            localStorage.setItem('typeUser', 'local'); // marca como usuário local
            startWebSocket();
            navigate('/notepad');
            return true;
          }

          alert("Automatic login failed. Please log in manually.");
          return false;
        }

        alert("No email found in Android app.");
        return false;

      } else {
        if (!isApp) {
          let storedEmail = await getIndexedDbValue(FAKE_EMAIL_KEY);

          if (!storedEmail) {
            storedEmail = localStorage.getItem(FAKE_EMAIL_KEY);
          }

          let localEmail = storedEmail;
          if (!localEmail) {
            localEmail = createLocalEmail();
            localStorage.setItem(FAKE_EMAIL_KEY, localEmail);
            await setIndexedDbValue(FAKE_EMAIL_KEY, localEmail);
          }

          const localLoginResponse = await api.post('/auth/local', {
            localEmail,
            language: navigator.language || 'en-US'
          });

          if (localLoginResponse.status === 200) {
            localStorage.setItem('contConectado', true);
            localStorage.setItem('typeUser', 'local');
            startWebSocket();
            navigate('/notepad');
            return true;
          } else {
            alert("Automatic login failed. Please log in manually.");
            return false;
          }
        } else {
          // caso não consiga se comunicar com o app android, mostra mensagem de erro e redireciona para login manual
          alert(t("Update your app to the latest version or try again."));
          return false;
        }
      }
    } finally {
      loginLocalInProgress.current = false;
    }
  }



  //hook para validar o login automático
  useEffect(() => {
    async function checkAuth() {
      const firstAccess = localStorage.getItem('firstAccess');

      // se já está conectado, navega direto para o notepad
      if (localStorage.getItem('contConectado') === 'true') {
        console.log("Auto login successful!");
        navigate('/notepad');
        return;
      }

      if (isApp) {
        if (firstAccess === null || firstAccess === 'true') {
          setLoading(true);
          const loggedIn = await loginWithLocalAccount();
          if (loggedIn) {
            return;
          }
          setLoading(false);
          setformLogin(true);
          return;
        }
      }

      // para web, ou app após o primeiro acesso, mostra a tela de escolha / formulário
      if (firstAccess === null || firstAccess === 'true' || localStorage.getItem('localUserBlock') !== 'true') {
        setShowFirstLogin(true);
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
          setformLogin(true);
        }, 1000);
        return;
      }

      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        setformLogin(true);
      }, 1000);
    }
    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isApp, navigate]);



  // hook para configurar mensagem de erro
  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => setErrorMessage(""), 5000);
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);



  // função para efetuar login
  async function handleSubmit(e) {
    e.preventDefault();
    setIsSubmitting(true); // Ativa o estado de carregamento
    setErrorMessage(""); // Limpa mensagens anteriores

    try {
      const response = await api.post('/auth/login', {
        email,
        password: senha,
        continuarConectado,
        language: navigator.language || 'en-US'
      });

      // envia token para camada nativa do android (WebView) para autenticação nas requisições
      if (window.Android && typeof window.Android.setCookie === 'function') {
        window.Android.setCookie("token", response.data.token);
      }

      if (response.status === 200) {
        localStorage.setItem('contConectado', continuarConectado);
        localStorage.setItem('typeUser', 'registrado'); // marca como usuário registrado
        //console.log(response.data.msg || 'Login bem-sucedido!'); // para desenvolvimento
        startWebSocket();
        navigate('/notepad')
      }
    } catch (error) {
      //console.log("Erro no login:", error.response.data.msg); // para desenvolvimento
      if (error.response?.status === 401) {
        setErrorMessage(error.response.data.msg || t("Invalid credentials. Please check your email and password."));// traduzir para ingles
      } else if (error.response?.status >= 500) {
        setErrorMessage(t("Server error. Please try again later."));
      }

    } finally {
      setIsSubmitting(false); // Desativa o carregamento
    }
  }

  // 2. Função para processar o token
  const handleGoogleSuccess = useCallback((idToken) => {
    googleOAuth.processGoogleLogin(idToken, navigate, setErrorMessage, setIsSubmitting, t);
  }, [navigate, t]);

  // Expor funções globais para o App Android (WebView)
  useEffect(() => {
    const cleanup = googleOAuth.setupGoogleNativeCallbacks(
      (idToken) => handleGoogleSuccess(idToken),
      (statusCode) => {
        console.error("Google Login Failure. Status Code:", statusCode);
        setErrorMessage(t("Failed to authenticate with Google."));
        setIsSubmitting(false);
      }
    );

    return cleanup;
  }, [handleGoogleSuccess, t]);


  // html do componente
  return (
    <>
      {loading ? (
        // modal de carregamento inicial
        <div className={styles.loaderContainer}>
          <div className={styles.loader}>
            <div className={styles.logoConteiner}>
              {window.matchMedia("(prefers-color-scheme: dark)").matches ? (
                <img src={logoLoadDarkTheme} alt="Logo da toSky notes" className={styles.logoLoadImg} />
              ) : (
                <img src={logoLoad} alt="Logo da toSky notes" className={styles.logoLoadImg} />
              )}
            </div>
            <ClipLoader color="#36D7B7" loading={loading} size={50} />
          </div>
        </div>
      ) : (

        <>
          {formLogin && (
            <>
              {/* modal para recuperação de senha */}
              <ForgotPasswordModal isOpen={isForgotPasswordModalOpen} onClose={() => setForgotPasswordModalOpen(false)} />

              <GoogleOAuthProvider clientId={googleOAuth.GOOGLE_CLIENT_ID}>
                <div className={styles.container}>



                  <div className={styles.loginBox}>
                    {/* cabeçalho com logo e título do app*/}
                    <div className={styles.brand} style={isApp ? { top: '45px' } : { top: '5px' }}>
                      <div className={styles.logoCircle}>
                        <span className={styles.logoText}><img src={logoHeader} alt="Logo da toSky notes" className={styles.logoImage} /></span>
                      </div>
                      <span className={styles.brandName}>tS notes</span>
                    </div>
                    <h2 className={styles.title}>{t("Login")}</h2>

                    {/* formulário de cadastro */}
                    <form onSubmit={handleSubmit} className={styles.form}>
                      {errorMessage && (
                        <div className={`${styles.error} ${errorMessage.includes("Credenciais") ? styles.auth : styles.server}`}>
                          <p>{errorMessage}</p>
                        </div>
                      )}
                      <input
                        type="email"
                        placeholder="E-mail"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className={styles.input}
                      />
                      <input
                        type="password"
                        placeholder={t("Password")}
                        value={senha}
                        onChange={(e) => setSenha(e.target.value)}
                        required
                        className={styles.input}
                      />
                      <div className={styles.checkboxContainer}>
                        <input
                          type="checkbox"
                          id="continuarConectado"
                          checked={continuarConectado}
                          onChange={() => setContinuarConectado(!continuarConectado)}
                        />
                        <label htmlFor="continuarConectado">{t("Continue connected")}</label>
                      </div>
                      <button type="submit" className={styles.button} disabled={isSubmitting}>
                        {isSubmitting ? t("Please wait") : t("Login")}
                        {isSubmitting && (
                          <span className={styles.ellipsis}>
                            <span></span>
                            <span></span>
                            <span></span>
                          </span>
                        )}
                      </button>
                    </form>

                    {/* login com conta google */}
                    <div style={{ display: isApp ? 'none' : 'block' }}>
                      <GoogleLogin
                        onSuccess={(credentialResponse) => handleGoogleSuccess(credentialResponse.credential)}
                        onError={() => setErrorMessage(t("Failed to authenticate with Google."))}
                        theme="outline"
                        type="standard"
                        shape="pill"
                        width="285px"
                        text="signin_with"
                      />
                    </div>

                    {/* login com conta google (Botão para o App Nativo) */}
                    {isApp && (
                      <div className={styles.googleAppButtonContainer}>
                        <button
                          type="button"
                          className={styles.googleAppButton}
                          onClick={() => googleOAuth.handleNativeGoogleLogin(t, setErrorMessage)}
                        >
                          <FcGoogle className={styles.googleIconApp} />
                          <span>{t("Sign in with Google")}</span>
                        </button>
                      </div>
                    )}


                    {/* form para caso usuário esquecer senha */}
                    <Link className={styles.link} onClick={() => setForgotPasswordModalOpen(true)}>
                      {t("Forgot password?")}
                    </Link>

                    {/* pagina para criação de novos cadastros */}
                    <div className={styles.cadastroContainer}>
                      <span>{t("Don't have an account?")}</span>
                      <Link to='/register' className={styles.link}>
                        {t("Sign up")}
                      </Link>
                    </div>

                    {/* painel de links para outras plataformas */}
                    <div className={styles.platformPanel}>
                      {isApp ? (
                        <a href="https://tsnotes.toskyapps.com" target="_blank" rel="noopener noreferrer" className={styles.platformLink}>
                          <FaGlobe className={styles.platformIcon} />
                          <span>{t("Access the Web version")}</span>
                        </a>
                      ) : (
                        <a href="https://play.google.com/store/apps/details?id=com.toskyapps.tsnotes" target="_blank" rel="noopener noreferrer" className={styles.platformLink}>
                          <FaGooglePlay className={styles.platformIcon} />
                          <span>{t("Download on Google Play")}</span>
                        </a>
                      )}
                    </div>

                  </div>

                </div>

                {/* MOSTRA MODAL DE PRIMEIRO LOGIN */}
                {showFirstLogin && (
                  <AppLogin
                    onCancel={() => setShowFirstLogin(false)}
                    onLogin={() => { loginWithLocalAccount() }}
                  />
                )}

              </GoogleOAuthProvider>
            </>
          )}
        </>
      )}
    </>
  );
}